import React, { useState } from "react";
import * as api from "../../api/index.js";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiMail, FiLock, FiChevronRight, FiSend } from "react-icons/fi";

const GenerateCodePage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const res = await api.generateResetCode(email);
      setMessage(res.data.message || "Reset code sent successfully!");

      setTimeout(() => {
        navigate("/reset", { state: { email } });
      }, 1500);
    } catch (err) {
      const msg =
        err.response?.data?.error || "Something went wrong. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-50"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-orange-50 rounded-full blur-3xl opacity-50"></div>

      {/* Header */}
      <div className="p-6 relative z-10">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-900 group"
        >
          <div className="p-2 bg-white rounded-full shadow-sm group-hover:bg-orange-50 transition-colors">
            <IoMdArrowBack size={20} />
          </div>
          <span className="text-xs font-black uppercase tracking-widest">Go Back</span>
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 relative z-10">
        <div className="max-w-md w-full bg-white rounded-[3rem] p-10 shadow-2xl shadow-gray-200/50 border border-gray-50 text-center">
          
          <div className="mb-10">
            <div className="w-20 h-20 bg-blue-50 text-blue-600 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-inner">
              <FiLock size={40} />
            </div>
            <h1 className="text-3xl font-black tracking-tighter text-gray-900 mb-3">
              Password Reset
            </h1>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest leading-relaxed">
              Enter your email address <br /> to receive a verification code
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-1 text-left">
              <label className="text-[10px] font-black text-gray-400 uppercase ml-1 tracking-widest">
                Email Address
              </label>
              <div className="relative">
                <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <input
                  type="email"
                  placeholder="name@example.com"
                  className="w-full pl-12 pr-4 py-4 bg-gray-50 border-transparent rounded-2xl focus:bg-white focus:border-orange-500 transition-all text-sm font-bold outline-none"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-5 bg-gray-900 text-white rounded-[1.5rem] font-black text-xs uppercase tracking-[0.2em] shadow-xl shadow-gray-200 hover:bg-black transition-all active:scale-95 disabled:opacity-70 flex items-center justify-center gap-2"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <>
                  Send Reset Code
                  <FiSend size={16} />
                </>
              )}
            </button>
          </form>

          {/* Feedback Messages */}
          {(error || message) && (
            <div className={`mt-8 p-4 rounded-2xl border text-[10px] font-black uppercase tracking-wider animate-in fade-in slide-in-from-bottom-2 ${
              message 
              ? "bg-green-50 border-green-100 text-green-600" 
              : "bg-red-50 border-red-100 text-red-600"
            }`}>
              {error || message}
            </div>
          )}
          
          <p className="mt-8 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            Remembered your password?{" "}
            <button 
              onClick={() => navigate("/login")}
              className="text-orange-600 hover:underline"
            >
              Log In
            </button>
          </p>
        </div>
      </div>

      <div className="p-8 text-center">
        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">
          Secure recovery process <br /> 
          <span className="text-gray-900">End-to-end encrypted</span>
        </p>
      </div>
    </div>
  );
};

export default GenerateCodePage;